import { IconContent } from '@icons';

export const bookFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M4.5 5.5a2 2 0 0 1 2-2H19v1H6.5a1 1 0 0 0 0 2H19v14H7A2.5 2.5 0 0 1 4.5 18V5.5Zm3.5 4h8v1H8v-1ZM8 12h8v1H8v-1Z" />',
};
